import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../../../../_metronic/helpers'
import {Data, QueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const URL = `${API_URL}/ticket`
const GET_URL = `${API_URL}/ticket/query`

const getData = (query: string): Promise<QueryResponse> => {
  return axios
    .get(`${GET_URL}?${query}`)
    .then((d: AxiosResponse<QueryResponse>) => d.data)
}

const getStatus = (): Promise<AxiosResponse<Array<{id: string; name: string}>>> => {
  return Promise.resolve({
    data: [
      {id: 'Open', name: 'Open'},
      {id: 'Assign', name: 'Assign'},
      {id: 'Closed', name: 'Closed'}
    ],
    status: 200,
    statusText: 'OK',
    headers: {},
    config: {} as any,
  })
}

const getDataById = (id: ID): Promise<Data | undefined> => {
  return axios.get(`${URL}/${id}`).then((res) => res.data)
}

const getCategories = async (): Promise<string[]> => {
  try {
    const response = await axios.get<string[]>(`${URL}/categories`)
    return response.data
  } catch (error) {
    console.error('Failed to fetch categories:', error)
    return []
  }
}


const getRequestType = async (): Promise<string[]> => {
  try {
    const response = await axios.get<string[]>(`${URL}/requesttype`)
    return response.data
  } catch (error) {
    console.error('Failed to fetch request type:', error)
    return []
  }
}


const checkPolicy = async (nopolicy): Promise<string[]> => {
  try {
    const response = await axios.get<string[]>(`${URL}/checkpolicy/${nopolicy}`)
    return response.data
  } catch (error) {
    console.error('Failed to fetch check policy:', error)
    return []
  }
}

const checkHistory = async (nopolicy): Promise<string[]> => {
  try {
    const response = await axios.get<string[]>(`${URL}/checkhistory/${nopolicy}`)
    return response.data
  } catch (error) {
    console.error('Failed to fetch check history policy:', error)
    return []
  }
}

const createData = (ticket: Data): Promise<Data | undefined> => {
  return axios
    .post(URL, ticket)
    .then((response: AxiosResponse<Data>) => response.data)
    .catch((error) => {
      console.error('Error in createData:', error)
      return undefined
    })
}

const updateData = (ticket: Data): Promise<Data | undefined> => {
  return axios
    .put(`${URL}/${ticket.id}`, ticket)
    .then((response: AxiosResponse<Data>) => response.data)
    .catch((error) => {
      console.error('Error in updateData:', error)
      return undefined
    })
}

const deleteData = (ticketId: ID): Promise<void> => {
  return axios.delete(`${URL}/${ticketId}`).then(() => {})
}

const deleteSelectedData = (ticketIds: Array<ID>): Promise<void> => {
  const requests = ticketIds.map((id) => axios.delete(`${URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getData, getStatus, deleteData, deleteSelectedData, getDataById, createData, updateData, getCategories, getRequestType, checkPolicy, checkHistory}
